import "stylesheets/components/common/LoadSpinner.css";
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Propulator from "higher-order/Propulator";
import Modal from "../../../components/common/Modal";
import isEmpty from "lodash/isEmpty";
import { ActionRootContext } from "higher-order/ActionRoot";

const LoadingSpinner = () => {
    return (<div className="loader"><div /><div /><div /><div /></div>);
};

@observer
class LoadSpinner extends React.Component {
    static contextType = ActionRootContext;

    static propTypes = {
        model: PropTypes.object
    }

    getLoader() {
        return (
            <div className={isEmpty(this.props.model.message) ? "no-message" : "has-message"}>
                <LoadingSpinner />
                <div className="message">{this.props.model.message}</div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                modalKey="loadSpinner"
                title="Loading"
                hideHeader={true}
                allowScrollBar={true}
                isOpen={this.props.model.isOpen}
                className="load-spinner"
                customOverlayClassName="load-spinner-overlay"
                shouldCloseOnOverlayClick={false}
            >
                {this.getLoader()}
            </Modal>
        );
    }
}

const LoadingOverlay = Propulator(LoadSpinner, {
    messageStore: {
        loadSpinner: "model"
    }
});

export { LoadingSpinner, LoadingOverlay };
